// const BACKEND_URL = 'https://1rzhjc5v-21055.inc1.devtunnels.ms/'
const BACKEND_URL = 'https://admin-stg-api.worqua.com/'
const BACKEND_URL2 = 'https://admin-stg-api.worqua.com/'


//const BACKEND_URL = 'https://stage-api.worqua.com/'
// const BACKEND_URL = 'https://service.worqua.com/'
// const BACKEND_URL = 'https://service.salescenter.ai/'
// const BACKEND_URL = 'https://salescenterba.azurewebsites.net/'
// const OauthHost = '//localhost:21055';
// export const BACKEND_URL_LOCAL = 'http://localhost:63661/api'
const OauthProtocol = 'http';
const OauthClientId = '';
const OauthPort = '';
const OauthSecret = '';

export const environment = {
  apiBaseUrl: BACKEND_URL + 'api/services/app',
 apiBaseUrl2: BACKEND_URL2 + 'api',  // apiBaseUrlLocal: BACKEND_URL_LOCAL,
  baseUrl: BACKEND_URL,
  assetUrl: BACKEND_URL + '/SmartOfficerAttachment',
  production: false,
  googleClientId: "463817211807-kd2tc0n3us50bc4qt5srp9jvr7qoa4oi.apps.googleusercontent.com",
  facebookAppId: "920731608966698",
  oauth: {
    // host: OauthHost,
    port: OauthPort,
    protocol: OauthProtocol,
    // path: 'api/Auth/login',
    path: 'api/TokenAuth/InfinitySignin',
    client_id: OauthClientId,
    secret: OauthSecret,
  },
  urls: {
    //user managment
    // USERS_GETALL: '/User/GetAll',
    USERS_GETALL: '/User/GetAllUsers',
    USER_GETBYID: '/User/GetUserById',
    ROLES_GETALL: '/Role/GetAll',
    USER_POST: '/User/Create',
    USER_CreateNew: '/User/CreateNew',
    USER_UDPATE: '/User/Update',
    ROLE_GET: '/Role/Get',
    ROLE_UPDATE: '/Role/Update',
    User_SendResetPasswordEmail: '/User/SendResetPasswordEmail',
    User_SetNewPassword: '/User/SetNewPassword',
    User_ChangePassword: '/User/ChangePassword',
    User_Check_OTP: '/User/CheckOTP',
    User_Change_Password_ByOTP: '/User/ChangePasswordByOTP',
    User_Expire_Old_OTP: '/User/ExpireOldOTP',
    User_Enable: '/User/Enable',
    User_Disable: '/User/Disable',
    User_GrantAccess: '/User/GrantAccess',

    Is_Tenant_Available: "/Account/IsTenantAvailable",
    Get_Setting_By_TenantId: "/CustomSetting/GetSettingByTenantId",

    TICKET_GETALL: '/Ticket/GetTickets',
    TICKET_ONMAP: '/Ticket/GetAllTicketByCurrentUser',
    TICKET_GETBYID: '/Ticket/GetTicketById',

    ATTENDANCE_GETALL: '/OfficerAttendance/GetAttendanceLog',

    TICKET_GETTICKETTYPE: '/Ticket/GetAllTicketType',

    ROLE_CREATE: '/Role/Create',

    PERMISSIONS_GET: '/Role/GetAllPermissions',
    PERMISSIONGETAll: '/Permission/GetAllPermissions',


    CREATE_HIERARCHY: '/Department/AddDepartmentUserMapping',
    GET_HIERARCHY: '/Department/GetUserDepartmentMapping',
    USERS_BY_ROLE: '/User/GetUserByRole',

    AUDIT_LOGS_GET: '/AuditLog/GetAuditLogs',

    LATEST_USERS_LOCATION_GET: '/UserLocation/GetLatestUsersLocation',

    USER_GET: '/User/Get',


    AUDIT_TYPES_GET: '/Auditor/GetAuditTypes',

    Notification_GET_ALL: '/Notification/GetNotifications',
    Notification_Get_Unseen_Notification_Count: '/Notification/GetUnseenNotificationCount',
    Notification_Update_Notification: '/Notification/UpdateNotification',
    Notification_Save_Task_Group: '/Notification/SaveTaskGroup',
    Notification_Get_Notification_Groups: '/Notification/GetNotificationGroups',
    Notification_Get_NotificationGroup_ById: '/Notification/GetNotificationGroupById',
    Notification_Update_NotificationGroup: '/Notification/UpdateNotificationGroup',
    Notification_Delete_NotificationGroup: '/Notification/DeleteNotificationGroup',

    Upload_Upload_Web_Single_File: '/Upload/UploadWebSingleFile',
    Upload_Ticket_Request_Attachment: '/Upload/UploadTicketRequestAttachment',
    Upload_General_Single_File: '/Upload/UploadGeneralSingleFile',
    Upload_Download: '/Upload/Download',
    Upload_Download_Ticket_Request_Attachment: '/Upload/DownloadTicketRequestAttachment',
    Upload_Delete_File: '/Upload/DeleteFile',
    Upload_Download_Export_To_Excel_TempFile: '/Upload/DownloadExportToExcelTempFile',
    Send_Email_On_Completed_Invoice: "/Upload/SendEmailOnCompletedInvoice",
    Send_Email_On_Customer_Statement_InReceivable: "/Upload/SendEmailOnCustomerStatementInReceivable",
    Send_Sms_On_Completed_Invoice: "/Upload/SendSmsOnCompletedInvoice",
    Send_Email_On_Estimate_WorkOrder: "/Upload/SendEmailOnEstimateWorkOrder",


    Reporting_Expense_ReportToExcel: '/Reporting/ExpenseReportToExcel',
    Reporting_MainCategories_ReportToExcel: '/Reporting/MainCategoriesReportToExcel',

    POSUploadFile_General_Single_File: '/POSUploadFile/UploadGeneralSingleFile',
    POSUploadFile_Download_Export_To_Excel_TempFile: '/POSUploadFile/DownloadExportToExcelTempFile',

    // SalesLeads
    SalesLeads_GetAll: '/SalesLeads/GetAll',
    SalesLeads_Delete: '/SalesLeads/Delete',
    SalesLeads_GetAllLeadStatus: '/SalesLeads/GetAllLeadStatus',
    SalesLeads_UpdateLeadStatus: '/SalesLeads/UpdateLeadStatus',
    SalesLeads_Update: '/SalesLeads/Update',
    SalesLeads_GetLeadDetailById: '/SalesLeads/GetLeadDetailById',
    SalesLeads_UpdateLeadInfo: '/SalesLeads/UpdateLeadInfo',
    SalesLeads_UpdateLeadClassification: '/SalesLeads/UpdateLeadClassification',
    SalesLeads_UpdateLeadContact: '/SalesLeads/UpdateLeadContact',
    SalesLeads_UpdateLeadAddress: '/SalesLeads/UpdateLeadAddress',
    SalesLeads_UpdateLeadInfluence: '/SalesLeads/UpdateLeadInfluence',
    // SalesAccounts
    SalesAccounts_GetAll: '/SalesAccounts/GetAll',
    SalesAccounts_Delete: '/SalesAccounts/Delete',
    SalesAccounts_Update: '/SalesAccounts/Update',
    SalesAccounts_GetAccountsDetailById: '/SalesAccounts/GetAccountDetailById',
    // Languages
    Get_AllLanguages: '/TenantLanguage/GetAllLanguages',
    Update_LanguagesLables: '/TenantLanguage/UpdateLanguagesLables',
    Get_All_Language_Text: '/TenantLanguage/GetAllLanguageText',
    AutoTranslateLanguageText: '/TenantLanguage/AutoTranslateLanguageText',
    GetAll_ModuleNames: '/TenantLanguage/GetAllModuleNames',
    GetAll_ScreenNames: '/TenantLanguage/GetAllScreenNames',

    // SalesLookups
    SalesLookups_GetAllLeadStatus: '/SalesLookups/GetAllLeadStatus',
    SalesLookups_GetAllLeadStatusReason: '/SalesLookups/GetAllLeadStatusReason',
    SalesLookups_GetAllLeadPronouns: '/SalesLookups/GetAllLeadPronouns',
    SalesLookups_GetAllLeadAccounts: '/SalesLookups/GetAllLeadAccounts',
    SalesLookups_GetAllLeadEmployees: '/SalesLookups/GetAllLeadEmployees',
    SalesLookups_GetAllLeadsType: '/SalesLookups/GetAllLeadsType',
    SalesLookups_GetAllLeadsTradeshowAttendanceType: '/SalesLookups/GetAllLeadsTradeshowAttendanceType',
    SalesLookups_GetAllLeadsSource: '/SalesLookups/GetAllLeadsSource',
    SalesLookups_GetAllLeadsCustomerCategory: '/SalesLookups/GetAllLeadsCustomerCategory',
    SalesLookups_GetAllLeadsSalutation: '/SalesLookups/GetAllLeadsSalutation',
    SalesLookups_GetAllLeadsSourceDetail: '/SalesLookups/GetAllLeadsSourceDetail',
    SalesLookups_GetAllLeadsBrandType: '/SalesLookups/GetAllLeadsBrandType',
    SalesLookups_GetAllLeadsChannel: '/SalesLookups/GetAllLeadsChannel',
    SalesLookups_GetAllLeadsDecisionMaking: '/SalesLookups/GetAllLeadsDecisionMaking',
    SalesLookups_GetAllLeadsTypeOfBusiness: '/SalesLookups/GetAllLeadsTypeOfBusiness',
    SalesLookups_GetAllLeadsSalesGroup: '/SalesLookups/GetAllLeadsSalesGroup',
    SalesLookups_GetAllLeadsSubChannel: '/SalesLookups/GetAllLeadsSubChannel',
    SalesLookups_GetAllLeadsLocation: '/SalesLookups/GetAllLeadsLocation',
    SalesLookups_GetAllLeadsVerifiedReferral: '/SalesLookups/GetAllLeadsVerifiedReferral',
    SalesLookups_GetAllLeadsCSMTerritoryName: '/SalesLookups/GetAllLeadsCSMTerritoryName',
    SalesLookups_GetAllLeadsLookups: '/SalesLookups/GetAllLeadsLookups',
    SalesLookups_GetSelectedItemLables: '/SalesLookups/GetSelectedItemLables',
    SalesLookups_UpdateLookupLables: '/SalesLookups/UpdateLookupLables',
    SalesLookups_AutoTranslateLookupLables: '/SalesLookups/AutoTranslateLookupLables',
    SalesLookups_GetAllOpportunityLocationCount: '/SalesLookups/GetAllOpportunityLocationCount',
    SalesLookups_GetAllOpportunityPurchaseDecisionMaker: '/SalesLookups/GetAllOpportunityPurchaseDecisionMaker',
    SalesLookups_GetAllPaymentType: '/SalesLookups/GetAllPaymentType',
    SalesLookups_GetAllDownPaymentType: '/SalesLookups/GetAllDownPaymentType',
    SalesLookups_GetAllFinancingTypes: '/SalesLookups/GetAllFinancingTypes',
    SalesLookups_GetAllCompetitor: '/SalesLookups/GetAllCompetitor',
    SalesLookups_GetAllOpportunityStageReason: '/SalesLookups/GetAllOpportunityStageReason',
    SalesLookups_GetAllTypeOfSale: '/SalesLookups/GetAllTypeOfSale',
    SalesLookups_GetAllNumberOfSystems: '/SalesLookups/GetAllNumberOfSystems',
    SalesLookups_GetAllOpportunityStage: '/SalesLookups/GetAllOpportunityStage',
    SalesLookups_GetAllSalesSource: '/SalesLookups/GetAllSalesSource',
    SalesLookups_GetAllSalesSourceDetail: '/SalesLookups/GetAllSalesSourceDetail',
    SalesLookups_GetAllCities: '/SalesLookups/GetAllCities',
    SalesLookups_GetAllStates: '/SalesLookups/GetAllStates',
    SalesLookups_GetAllCountries: '/SalesLookups/GetAllCountries',
    SalesTerritory_GetAllTerritory: '/SalesTerritory/GetAllTerritory',
    SalesTerritory_GetAllGlobalRegion: '/SalesTerritory/GetAllGlobalRegion',
    SalesTerritory_GetAllRegion: '/SalesTerritory/GetAllRegion',
    SalesTerritory_GetAllSubRegion: '/SalesTerritory/GetAllSubRegion',
    // Employees
    // Employees
    Employee_GetAll: "/Employee/GetAll",
    Employee_CreateOrEdit: "/Employee/CreateOrEdit",
    Employee_GetAllEmployeeDropDown: "/Employee/GetAllEmployeeDropDown",
    Employee_GetEmployeeInfoById: "/Employee/GetEmployeeInfoById",
    Employee_UpdateEmployeeInfo: "/Employee/UpdateEmployeeInfo",
    Employee_GetEmployeeDepositeInfoById: "/Employee/GetEmployeeDepositeInfoById",
    Employee_UpdateEmployeeDepositeInfo: "/Employee/UpdateEmployeeDepositeInfo",
    Employee_GetEmployeeDaysOffInfoById: "/Employee/GetEmployeeDaysOffInfoById",
    Employee_UpdateEmployeeDaysOff: "/Employee/UpdateEmployeeDaysOff",
    Employee_username_taken: "/employee/username-taken-By-EmployeeId",
    Employee_email_taken_By_EmployeeId: "/employee/email-taken-By-EmployeeId",
    Employee_UpdateEmployeeWorkingHours: "/Employee/UpdateEmployeeWorkingHours",
    Employee_GetEmployeeWorkingHoursInfoById: "/Employee/GetEmployeeWorkingHoursInfoById",
    Employee_ChangePassword: "/Employee/ChangePassword",
    Employee_EnableOrDisableEmployee: "/Employee/EnableOrDisableEmployee",
    // Vendor
    // Vendor
    Vendor_GetAll: "/Vendor/GetAll",
    Vendor_Create: "/Vendor/Create",
    Vendor_Update: "/Vendor/Update",
    Vendor_GetVendorForEdit: "/Vendor/GetVendorForEdit",
    Vendor_GetAllVendorDropDown: "/Vendor/GetAllVendorDropDown",
    Vendor_Delete: "/Vendor/Delete",
    Vendor_EnableOrDisableVendor: "/Vendor/EnableOrDisableVendor",
    // VendorCategory
    // VendorCategory
    VendorCategory_GetAll: "/VendorCategory/GetAll",
    VendorCategory_Create: "/VendorCategory/Create",
    VendorCategory_Update: "/VendorCategory/Update",
    VendorCategory_GetVendorCategoryForEdit: "/VendorCategory/GetVendorCategoryForEdit",
    VendorCategory_Delete: "/VendorCategory/Delete",
    VendorCategory_EnableOrDisableVendorCategory: "/VendorCategory/EnableOrDisableVendorCategory",
    //VendorAddress
    //VendorAddress
    VendorAddress_GetAll: "/VendorAddress/GetAll",
    VendorAddress_Create: "/VendorAddress/Create",
    VendorAddress_Delete: "/VendorAddress/Delete",
    VendorAddress_Update: "/VendorAddress/Update",
    VendorAddress_EnableOrDisableVendorAddress: "/VendorAddress/EnableOrDisableVendorAddress",
    // VendorDocument
    // VendorDocument
    VendorDocument_GetAll: "/VendorDocument/GetAll",
    VendorDocument_upload_vendor_documents: "/upload-vendor-documents",
    // Customer
    Customer_GetAll: "/Customer/GetAll",
    Customer_CustomerCreateOrEdit: "/Customer/Create",
    Customer_Update: "/Customer/Update",
    Customer_GetAllCustomerDropdown: "/Customer/GetAllCustomerDropdown",
    Customer_GetCustomerDetail: "/Customer/GetCustomerDetail",
    Customer_GetTagsForCustomer: "/Customer/GetTagsForCustomer",
    Customer_AddMultipleTagsForCustomer: "/Customer/AddMultipleTagsForCustomer",

    // CustomerCreditCard
    CustomerCreditCard_GetAll: "/CustomerCreditCard/GetAll",
    CustomerCreditCard_CreateOrEdit: "/CustomerCreditCard/CustomerCreditCardCreateOrEdit",
    CustomerCreditCard_GetAllDropdown: "/CustomerCreditCard/GetAllCustomerCreditCardDropdown",
    CustomerCreditCard_Delete: "/CustomerCreditCard/Delete",
    CustomerCreditCard_GetById: "/CustomerCreditCard/GetById",

    // /FilesBox
    FilesBox_UploadFiles: "/FilesBox/UploadFiles",
    FilesBox_GetAllFiles: "/FilesBox/GetAllFiles",
    upload_General_Single_File_Async: "/Upload/UploadFile",

    // Tag
    Tag_CreateTag: "/Tag/CreateTag",
    Tag_DeleteTag: "/Tag/DeleteTag",
    Tag_UpdateTag: "/Tag/UpdateTag",
    Tag_GetTagById: "/Tag/GetTagById",
    Tag_GetAllList: "/Tag/GetAll",
    //using in all dropdown
    Tag_GetAll: "/Tag/GetAllTagsForDropDown",
    Tag_EnableDisableTag: "/Tag/EnableDisableTag",

    // CustomerAddress
    CustomerAddress_GetAll: "/CustomerAddress/GetAll",
    CustomerAddress_CreateOrEdit: "/CustomerAddress/CustomerAddressCreateOrEdit",
    CustomerAddress_Delete: "/CustomerAddress/Delete",
    CustomerAddress_GetTags: "/CustomerAddress/GetTagsForCustomerAddress",
    CustomerAddress_AddMultipleTags: "/CustomerAddress/AddMultipleTagsForCustomerAddress",
    CustomerAddress_GetAddressById: "/CustomerAddress/GetAddressById",
    Get_Customer_Address_To_ViewOnInvoice: "/CustomerAddress/GetCustomerAddressToViewOnInvoice",

    // CustomerEquipment
    CustomerEquipment_GetEquipments: "/CustomerEquipment/GetCustomerEquipments",
    CustomerEquipment_GetEquipmentForEdit: "/CustomerEquipment/GetCustomerEquipmentForEdit",
    CustomerEquipment_CreateEquipment: "/CustomerEquipment/CreateCustomerEquipment",
    CustomerEquipment_UpdateEquipment: "/CustomerEquipment/UpdateCustomerEquipment",
    CustomerEquipment_Delete: "/CustomerEquipment/DeleteCustomerEquipment",
    // Division
    Division_GetAll: "/Division/GetAll",
    Division_GetDivisionForEdit: "/Division/GetDivisionForEdit",
    Division_Delete: "/Division/Delete",
    Division_Create: "/Division/Create",
    Division_Update: "/Division/Update",
    Division_EnableOrDisableDivision: "/Division/EnableOrDisableDivision",

    // Price book
    Service_GetAll: "/Services/GetAll",
    Get_Service_For_Edit: "/Services/GetServiceForEdit",
    Service_Delete: "/Services/Delete",
    Service_Create: "/Services/Create",
    Service_Update: "/Services/Update",
    Get_All_Service_DropDown: "/Services/GetAllServiceDropDown",
    Service_EnableOrDisableService: "/Services/EnableOrDisableService",

    // Price book category
    Service_Category_GetAll: "/ServiceCategory/GetAll",
    Get_Service_Catagory_For_Edit: "/ServiceCategory/GetServiceCatagoryForEdit",
    Service_Catagory_Delete: "/ServiceCategory/Delete",
    Service_Catagory_Create: "/ServiceCategory/Create",
    Service_Catagory_Update: "/ServiceCategory/Update",
    Service_Catagory_EnableOrDisableServiceCatagory: "/ServiceCategory/EnableOrDisableServiceCatagory",

    // Team
    Team_GetAll: "/Team/GetAll",
    Team_GetTeamForEdit: "/Team/GetTeamForEdit",
    Team_Delete: "/Team/Delete",
    Team_Create: "/Team/Create",
    Team_Update: "/Team/Update",
    Team_GetTeamAllDropDown: "/Team/GetTeamAllDropDown",

    // TeamMember
    TeamMember_GetAllTech: "/TeamMember/GetAllTech",
    TeamMember_GetAllTeamMember: "/TeamMember/GetAllTeamMember",
    TeamMember_CreateTeamMembers: "/TeamMember/CreateTeamMembers",
    TeamMember_DeleteMember: "/TeamMember/DeleteMember",

    // WorkOrder
    WorkOrder_GetAll: "/WorkOrder/GetAll",
    WorkOrder_Get: "/WorkOrder/Get",
    WorkOrder_WorkOrderByCustomerAddress: "/WorkOrder/WorkOrderByCustomerAddress",
    WorkOrder_WorkOrderByCustomer: "/WorkOrder/WorkOrderByCustomer",
    WorkOrder_WorkOrderCreateOrEdit: "/WorkOrder/WorkOrderCreateOrEdit",
    WorkOrder_GetCustomers: "/WorkOrder/GetCustomers",
    WorkOrder_GetAllWorkOrderDropdown: "/WorkOrder/GetAllWorkOrderDropdown",
    WorkOrder_GetServiceAddressHistory: "/WorkOrder/GetServiceAddressHistory",
    WorkOrder_GetAllTechniciansForConvertEstimate: "/WorkOrder/GetAllTechniciansForConvertEstimateToSoldJob",
    WorkOrder_GetAllTechnicians: "/WorkOrder/GetAllTechnicians",
    WorkOrder_CheckTechniciansAvailability: "/WorkOrder/CheckTechniciansAvailability",
    WorkOrder_ChangeWorkOrderStatus: "/WorkOrder/ChangeWorkOrderStatus",
    Convert_Estimate_To_Sold_Job: "/WorkOrder/ConvertEstimateToSoldJob",

    //WorkOrder AI?/////
    WorkOrder_ExtractOpenAIDescription: "/WorkOrder/ExtractOpenAIDescription",
    // Customer Work Order History
    // Customer Work Order History

    CustomerWorkOrderHistory_getCustomerHistory: "/CustomerWorkOrderHistory/getCustomerWorkOrderHistory",
    CustomerWorkOrderHistory_getInvoiceServicesHistory: "/CustomerWorkOrderHistory/getInvoiceServicesHistory",
    CustomerWorkOrderHistory_GetAllWorkOrderImages: "/CustomerWorkOrderHistory/GetAllWorkOrderImages",


    // Invoice
    GetAll_Invoices: "/Invoice/GetAll",
    Get_All_InvoiceServices: "/Invoice/GetAllInvoiceServices",
    Get_Invoice_By_Id: "/Invoice/Get",
    Invoice_Create_Or_Edit: "/Invoice/InvoiceCreateOrEdit",
    get_Tags_For_Invoice: "/Invoice/getTagsForInvoice",
    Get_Tax_Codes_DropDown_For_Invoice: "/Invoice/GetTaxCodesDropDown",
    Get_All_Po_Dropdowns_For_Invoice: "/Invoice/GetAllPoDropdowns",
    Add_Update_Invoice_Services: "/Invoice/AddUpdateInvoiceServices",
    Delete_Custome_Invoice_Service: "/Invoice/DeleteCustomeInvoice",
    Get_Invoice_Service_By_Id: "/Invoice/GetInvoiceServiceById",
    Get_Invoice_Payments: "/Invoice/GetInvoicePayments",
    Pay_Invoice_Amount: "/Invoice/PayInvoiceAmount",
    Delete_Invoice_Payment: "/Invoice/DeleteInvoicePayment",
    Get_All_Customer_Credit_Cards: "/Invoice/GetAllCustomerCreditCards",
    Update_Invoice_Address_Detail_Tab: "/Invoice/UpdateInvoiceAddressDetailTab",
    Update_Invoice_Services_Tab: "/Invoice/UpdateInvoiceServicesTab",
    Update_Invoice_Signature_Tab: "/Invoice/UpdateInvoiceSignatureTab",
    Get_Purchase_Orders: "/Invoice/GetPurchaseOrders",
    Get_Purchase_For_Edit: "/Invoice/GetPurchaseForEdit",
    Create_Edit_Purchase_Order: "/Invoice/CreateEditPurchaseOrder",
    Get_PurchaseOrder_Number_In_Invoice: "/Invoice/GetPurchaseOrderNumberInInvoice",
    Delete_Purchase_Order: "/Invoice/DeletePurchaseOrder",
    Completed_Invoice: "/Invoice/CompletedInvoice",
    Print_Payment_Invoice: "/Invoice/PrintPaymentInvoice",


    // PurchaseOrder
    // PurchaseOrder
    PurchaseOrder_GetAllPayableVendors: "/PurchaseOrder/GetAllPayableVendors",
    PurchaseOrder_GetAllVendorPurchaseOrders: "/PurchaseOrder/GetAllVendorPurchaseOrders",
    PurchaseOrder_GetPayableDetailForEdit: "/PurchaseOrder/GetPayableDetailForEdit",
    PurchaseOrder_IsInvoiceNumberValidt: "/PurchaseOrder/IsInvoiceNumberValid",
    PurchaseOrder_GetPaymentForEdit: "/PurchaseOrder/GetPaymentForEdit",
    PurchaseOrder_GetPayableVendorDetail: "/PurchaseOrder/GetPayableVendorDetail",
    PurchaseOrder_GetPayablePurchaseOrders: "/PurchaseOrder/GetPayablePurchaseOrders",
    PurchaseOrder_GetPayableVendorForDropDown: "/PurchaseOrder/GetPayableVendorForDropDown",
    PurchaseOrder_GetPurchaseOrderDueAmount: "/PurchaseOrder/GetPurchaseOrderDueAmount",
    PurchaseOrder_GetPaymentMethodForDropDown: "/PurchaseOrder/GetPaymentMethodForDropDown",
    PurchaseOrder_CreateOrUpdatePayment: "/PurchaseOrder/CreateOrUpdatePayment",
    PurchaseOrder_GetVendorForDropDown: "/PurchaseOrder/GetVendorForDropDown",
    PurchaseOrder_GetVendorPaymentHistoryDetail: "/PurchaseOrder/GetVendorPaymentHistoryDetail",
    PurchaseOrder_GetVendorPaymentHistory: "/PurchaseOrder/GetVendorPaymentHistory",
    PurchaseOrder_UnPayVendorPayment: "/PurchaseOrder/UnPayVendorPayment",
    PurchaseOrder_PrintVendorPaymentHistoryDetails: "/PurchaseOrder/PrintVendorPaymentHistoryDetails",
    PurchaseOrder_DeletePayableDetail: "/PurchaseOrder/DeletePayableDetail",
    PurchaseOrder_UpdatePayableDetail: "/PurchaseOrder/UpdatePayableDetail",
    PurchaseOrder_GetVendorPaymentDetail: "/PurchaseOrder/GetVendorPaymentDetail",
    PurchaseOrder_Create: "/PurchaseOrder/Create",
    PurchaseOrder_GetPurchaseOrderPicture: "/PurchaseOrder/GetPurchaseOrderPicture",
    PurchaseOrder_GetPurchaseOrderNumber: "/PurchaseOrder/GetPurchaseOrderNumber",
    PurchaseOrder_PrintPaymentInvoice: "/PurchaseOrder/PrintPaymentInvoice",

    // Receivable
    Receivable_GetAllReceivalbeCustomer: "/Receivable/GetAllReceivalbeCustomer",
    Receivable_GetCustomerUnpaidInvoices: "/Receivable/GetCustomerUnpaidInvoices",
    Receivable_GetCustomerNotes: "/Receivable/GetCustomerNotes",
    Receivable_UpdateCustomerNotes: "/Receivable/UpdateCustomerNotes",
    Receivable_GetWorkOrderNotes: "/Receivable/GetWorkOrderNotes",
    Receivable_UpdateWorkOrderNotes: "/Receivable/UpdateWorkOrderNotes",
    Receivable_CustomerReceivableHistory: "/Receivable/CustomerReceivableHistory",
    Receivable_PrintCustomerReceivableHistory: "/Receivable/PrintCustomerReceivableHistory",
    Receivable_CustomerReceivableHistoryDetail: "/Receivable/CustomerReceivableHistoryDetail",
    Receivable_PrintCustomerReceivableHistoryDetail: "/Receivable/PrintCustomerReceivableHistoryDetail",
    Receivable_PrintCustomerStatement: "/Receivable/PrintCustomerStatement",
    Receivable_GetInvoicePaymentDetail: "/Receivable/GetInvoicePaymentDetail",
    Receivable_CreatePayment: "/Receivable/CreatePayment",
    Receivable_UnPayCustomerPayment: "/Receivable/UnPayCustomerPayment",
    Receivable_RevenueReportInReceivable: "/Receivable/RevenueReportInReceivable",
    Receivable_PrintRevenueReportPdfInReceivable: "/Receivable/PrintRevenueReportPdfInReceivable",
    Receivable_RevenueReportForCSVInReceivable: "/Receivable/RevenueReportForCSVInReceivable",
    Receivable_GetCustomerCreditCardList: "/Receivable/GetCustomerCreditCardList",


    // Price book category
    Email_Template_GetAll: "/EmailTemplate/GetAll",
    Get_Email_Template_For_Edit: "/EmailTemplate/GetEmailTemplateForEdit",
    Update_Email_Template: "/EmailTemplate/UpdateEmailTemplate",

    // Revenue Reports
    Get_Revenue_Report: "/Reporting/GetRevenueReport",
    Get_Revenue_Report_To_Pdf: "/Reporting/GetRevenueReportToPdf",
    Get_Revenue_Report_To_Excel: "/Reporting/GetRevenueReportToExcel",

    // Invoice Reports
    Get_Invoice_Report: "/Reporting/GetInvoiceReport",
    Get_Invoice_To_Pdf_Report: "/Reporting/GetInvoiceToPdfReport",
    Get_Invoice_Report_To_Excel: "/Reporting/GetInvoiceReportToExcel",
    Get_Technician_DropDown: "/Reporting/GetTechnicianDropDown",
    Get_Customer_DropDown: "/Reporting/GetCustomerDropDown",

    //division Reports

    Get_GetAllGetDivision: "/Reporting/GetAllGetDivision",
    Division_DivisionPdfReport: "/Reporting/DivisionPdfReport",
    Division_DivionReportToExcel: "/Reporting/DivionReportToExcel",

    // Tax Reports///
    Get_TaxPaymentReportData: "/Reporting/GetTaxPaymentReportData",
    Tax_PaymentPdfReport: "/Reporting/TaxPaymentPdfReport",
    Tax_PaymentToExcel: "/Reporting/TaxPaymentToExcel",


    //Employee Report///


    Get_Employee_ReportData_Againt_WorkOrder: "/Reporting/GetEmployeeReportDataAgaintWorkOrder",
    Get_Employee_Details: "/Reporting/GetEmployeeDetails",
    // DashBoard
    // DashBoard
    DashBoard_DashBoardData: "/DashBoard/DashBoardData",
    DashBoard_DashBoardChartData: "/DashBoard/DashBoardChartData",
    DashBoard_GetSales: "/DashBoard/GetSales",
    DashBoard_GetYearlySalesComparison: "/DashBoard/GetYearlySalesComparison",
    DashBoard_GetEstimateConversion: "/DashBoard/GetEstimateConversion",
    DashBoard_GetHeatMapData: "/DashBoard/GetHeatMapData",

    // Inventory
    // Inventory
    Inventory_GetInventoryTruk: "/Inventory/GetInventoryTruk",
    Inventory_DeleteInventoryTruk: "/Inventory/DeleteInventoryTruk",
    Inventory_PrintRestockInventoryPdf: "/Inventory/PrintRestockInventoryPdf",
    Inventory_PrintOverStockSelectedLocationPdf: "/Inventory/PrintOverStockSelectedLocationPdf",
    Inventory_PrintCurrentSeletedListPdf: "/Inventory/PrintCurrentSeletedListPdf",
    Inventory_GetInventoryPart: "/Inventory/GetInventoryPart",
    Inventory_PrintTruckPartListPdf: "/Inventory/PrintTruckPartListPdf",
    Inventory_ExportToExcelTruckPartList: "/Inventory/ExportToExcelTruckPartList",
    Inventory_DeletePartList: "/Inventory/DeletePartList",
    Inventory_DeleteSelectedParts: "/Inventory/DeleteSelectedParts",
    Inventory_DeleteSelectedTruckPartList: "/Inventory/DeleteSelectedTruckPartList",
    Inventory_ShowOverStock: "/Inventory/ShowOverStock",
    Inventory_ShowOverRestock: "/Inventory/ShowOverRestock",
    Inventory_GetReasignPart: "/Inventory/GetReasignPart",
    Inventory_EditInventoryPartList: "/Inventory/EditInventoryPartList",
    Inventory_CreateInventoryPartList: "/Inventory/CreateInventoryPartList",
    Inventory_UpdateInventoryPartList: "/Inventory/UpdateInventoryPartList",
    Inventory_GetInventoryDropDown: "/Inventory/GetInventoryDropDown",
    Inventory_CreateOrEditInventoryTruk: "/Inventory/CreateOrEditInventoryTruk",
    Inventory_CreateInventoryTruck: "/Inventory/CreateInventoryTruck",
    Inventory_UpdateInventoryTruk: "/Inventory/UpdateInventoryTruk",
    Inventory_GetInventoryGroup: "/Inventory/GetInventoryGroup",
    Inventory_GetInventoryGroupForEdit: "/Inventory/GetInventoryGroupForEdit",
    Inventory_CreateInventoryGroup: "/Inventory/CreateInventoryGroup",
    Inventory_UpdateInventoryGroup: "/Inventory/UpdateInventoryGroup",
    Inventory_DeleteInventoryGroup: "/Inventory/DeleteInventoryGroup",
    Inventory_GetInventoryCategory: "/Inventory/GetInventoryCategory",
    Inventory_GetInventoryCategoryForEdit: "/Inventory/GetInventoryCategoryForEdit",
    Inventory_CreateInventoryCategory: "/Inventory/CreateInventoryCategory",
    Inventory_UpdateInventoryCategory: "/Inventory/UpdateInventoryCategory",
    Inventory_DeleteInventoryCategory: "/Inventory/DeleteInventoryCategory",
    Inventory_GetPartListByInventoryGroup: "/Inventory/GetPartListByInventoryGroup",
    Inventory_CreateInventoryPart: "/Inventory/CreateInventoryPart",
    Inventory_GetInventoryPartForEdit: "/Inventory/GetInventoryPartForEdit",
    Inventory_UpdateInventoryPart: "/Inventory/UpdateInventoryPart",
    Inventory_UpdateSelectedMarkups: "/Inventory/UpdateSelectedMarkups",
    Inventory_DeleteGroupPart: "/Inventory/DeleteGroupPart",
    Inventory_GetInventoryPartsFromMasterList: "/Inventory/GetInventoryPartsFromMasterList",
    Inventory_AssignPartsFromMasterList: "/Inventory/AssignPartsFromMasterList",
    Inventory_PrintInventroyGroupparts: "/Inventory/PrintInventroyGroupparts",
    Inventory_GetReassignParts: "/Inventory/GetReassignParts",
    Inventory_CreateReassignGroupParts: "/Inventory/CreateReassignGroupParts",
    Inventory_ReasignPartToTruckPart: "/Inventory/ReasignPartToTruckPart",
    Inventory_CreateRestockInventory: "/Inventory/CreateRestockInventory",
    // Inventory_GetInventoryPartsFromMasterList:"/Inventory/GetInventoryPartsFromMasterList",
    // Inventory_ReassignParts:"/Inventory/ReassignParts",

    // NewInventories/GetPartList
    // NewInventories/GetPartList

    NewInventories_GetPartList: "/NewInventories/GetPartList",
    NewInventories_GetInventoryCategory: "/NewInventories/GetInventoryCategory",
    NewInventories_GetInventoryCategoryForEdit: "/NewInventories/GetInventoryCategoryForEdit",
    NewInventories_CreateInventoryCategory: "/NewInventories/CreateInventoryCategory",
    NewInventories_UpdateInventoryCategory: "/NewInventories/UpdateInventoryCategory",
    NewInventories_DeleteInventoryCategory: "/NewInventories/DeleteInventoryCategory",
    NewInventories_CreateInventoryPart: "/NewInventories/CreatePart",
    NewInventories_UpdatePart: "/NewInventories/UpdatePart",
    NewInventories_GetInventoryDropDown: "/NewInventories/GetInventoryDropDown",
    NewInventories_GetPartForEdit: "/NewInventories/GetPartForEdit",
    NewInventories_GetInventoryWarehouse: "/NewInventories/GetInventoryWarehouse",
    NewInventories_GetInventoryWarehouseForEdit: "/NewInventories/GetInventoryWarehouseForEdit",
    NewInventories_CreateInventoryWarehouse: "/NewInventories/CreateInventoryWarehouse",
    NewInventories_UpdateInventoryWarehouse: "/NewInventories/UpdateInventoryWarehouse",
    NewInventories_DeleteInventoryWarehouse: "/NewInventories/DeleteInventoryWarehouse",
    NewInventories_GetWarehousePartList: "/NewInventories/GetWarehousePartList",
    NewInventories_GetPartsListForAssign: "/NewInventories/GetPartsListForAssign",
    NewInventories_GetWarehouses: "/NewInventories/GetWarehouses",
    NewInventories_AssignPartsFromMasterList: "/NewInventories/AssignPartsFromMasterList",
    NewInventories_GetInventoryLocation: "/NewInventories/GetInventoryLocation",
    NewInventories_DeleteInventoryLocation: "/NewInventories/DeleteInventoryLocation",
    NewInventories_CreateOrEditInventoryLocation: "/NewInventories/CreateOrEditInventoryLocation",
    NewInventories_CreateInventoryLocation: "/NewInventories/CreateInventoryLocation",
    NewInventories_UpdateInventoryLocation: "/NewInventories/UpdateInventoryLocation",
    NewInventories_GetLocationPartList: "/NewInventories/GetLocationPartList",
    NewInventories_GetAllLocationDropDown: "/NewInventories/GetAllLocationDropDown",
    NewInventories_RestockIntoLocation: "/NewInventories/RestockIntoLocation",
    NewInventories_UpdateWarehousePart: "/NewInventories/UpdateWarehousePart",
    NewInventories_GetWarehousePartForEdit: "/NewInventories/GetWarehousePartForEdit",
    NewInventories_UpdateLocationPart: "/NewInventories/UpdateLocationPart",
    NewInventories_GetLocationPartForEdit: "/NewInventories/GetLocationPartForEdit",
    NewInventories_DeleteInventoryPart: "/NewInventories/DeleteInventoryPart",
    NewInventories_GetInventoryEmployeeDropDown: "/NewInventories/GetInventoryEmployeeDropDown",


    // NewInventories/EnableDisable
    NewInventories_EnableOrDisableCategory: "/NewInventories/EnableOrDisableCategory",
    NewInventories_EnableOrDisableWarehouse: "/NewInventories/EnableOrDisableWarehouse",
    NewInventories_EnableOrDisableLocation: "/NewInventories/EnableOrDisableLocation",
    NewInventories_EnableOrDisablePart: "/NewInventories/EnableOrDisablePart",

    // /TaxCode
    // /TaxCode
    TaxCode_GetAll: "/TaxCode/GetAll",
    TaxCode_CreateOrEdit: "/TaxCode/CreateOrEdit",
    TaxCode_GetTaxCodeForEdit: "/TaxCode/GetTaxCodeForEdit",
    TaxCode_GetAllTaxCodeDropDown: "/TaxCode/GetAllTaxCodeDropDown",
    TaxCode_Delete: "/TaxCode/Delete",
    TaxCode_EnableOrDisableTaxCode: "/TaxCode/EnableOrDisableTaxCode",

    // /TaxCodeAgency
    // /TaxCodeAgency

    TaxCode_GetTaxAgencyList: "/TaxAgency/GetTaxAgencyList",
    TaxCode_TaxAgency_CreateOrEdit: "/TaxAgency/CreateOrEdit",
    TaxCode_TaxAgency_GetTaxCodeForEdit: "/TaxAgency/GetTaxCodeForEdit",
    TaxCode_TaxAgency_Delete: "/TaxAgency/Delete",
    TaxCode_TaxAgency_EnableOrDisableTaxAgence: "/TaxAgency/EnableOrDisableTaxAgence",

    // /Equipment Category

    Equipment_GetEquipmentsCetegory: "/Equipment/GetEquipmentsCetegory",
    Equipment_CreateEquipmentCategory: "/Equipment/CreateEquipmentCategory",
    Equipment_UpdateEquipmentCategory: "/Equipment/UpdateEquipmentCategory",
    Equipment_EnableOrDisableEquipmentCategory: "/Equipment/EnableOrDisableEquipmentCategory",

    // /Equipment

    Equipment_GetEquipments: "/Equipment/GetEquipments",
    Equipment_CreateEquipment: "/Equipment/CreateEquipment",
    Equipment_GetEquipmentForEdit: "/Equipment/GetEquipmentForEdit",
    Equipment_UpdateEquipment: "/Equipment/UpdateEquipment",
    Equipment_DeleteEquipment: "/Equipment/DeleteEquipment",
    Equipment_GetAllEquipmentDropdowns: "/Equipment/GetAllEquipmentDropdowns",
    Equipment_getEquipmentRepairHistory: "/Equipment/getEquipmentRepairHistory",
    Equipment_getEquipmentRepairHistoryForEdit: "/Equipment/getEquipmentRepairHistoryForEdit",
    Equipment_createEquipmentRepairHistory: "/Equipment/createEquipmentRepairHistory",
    Equipment_updateEquipmentRepairHistory: "/Equipment/updateEquipmentRepairHistory",
    Equipment_getAssignments: "/Equipment/getAssignments",
    Equipment_createAssignment: "/Equipment/createAssignment",
    Equipment_CheckInAssignment: "/Equipment/CheckInAssignment",
    Equipment_checkEquipmentAvailability: "/Equipment/checkEquipmentAvailability",
    Equipment_EnableOrDisableEquipment: "/Equipment/EnableOrDisableEquipment",

    // importexport
    importexport_uplodfile: '/ImportExport',
    importexport_GetUploadFileColumn: '/ImportExportService/GetUploadFileColumn',
    importexport_GetCustomerRawData: '/ImportExportService/GetCustomerRawData',
    importexport_ImportCustomersDataProcess: '/ImportExportService/ImportCustomersDataProcess',
    importexport_GetPriceBookRawData: '/ImportExportService/GetPriceBookRawData',
    importexport_GetVendorRawData: '/ImportExportService/GetVendorRawData',
    importexport_GetEmployeeRawData: '/ImportExportService/GetEmployeeRawData',
    importexport_ExportSelection: '/ImportExportService/ExportSelection',


    //Company-Setting/////
    Company_GetCompanyForEdit: "/Company/GetCompanyForEdit",
    Company_Update: "/Company/Update",
    Company_GetAllCompanyDropDown: "/Company/GetAllCompanyDropDown",
    Company_CreateUpdateProcessingProvider: "/Company/CreateUpdateProcessingProvider",
    Company_getProcessingProvider: "/Company/getProcessingProvider",
    Company_GetCCProcessingProviderDropDown: "/Company/GetCCProcessingProviderDropDown",
    Get_Email_Setup_For_Edit: "/Company/GetEmailSetupForEdit",


    //Company-Setting-Phone-Number/////

    CompanyPhoneNumber_GetAll: "/CompanyPhoneNumber/GetAll",
    CompanyPhoneNumber_GetCompanyPhoneNumberForEdit: "/CompanyPhoneNumber/GetCompanyPhoneNumberForEdit",
    CompanyPhoneNumber_Delete: "/CompanyPhoneNumber/Delete",
    CompanyPhoneNumber_Create: "/CompanyPhoneNumber/Create",
    CompanyPhoneNumber_Update: "/CompanyPhoneNumber/Update",

    //Email-setting///////


    Setting_GetAll: "/Setting/GetAll",
    Setting_GetSettingForEdit: "/Setting/GetSettingForEdit",
    Setting_Delete: "/Setting/Delete",
    Setting_Create: "/Setting/Create",
    Setting_Update: "/Setting/Update",







    // Terms Apis
    Get_Term_For_Dropdown: "/Terms/GetTermForDropdown",


    // Dispatch Board Apis
    Get_UnAssigned_WorkOrder_For_DispatchBoard_Grid: "/DispatchBoard/GetUnAssignedWorkOrderForDispatchBoardGrid",
    Get_Hold_WorkOrder_For_DispatchBoard_Grid: "/DispatchBoard/GetHoldWorkOrderForDispatchBoardGrid",
    Get_Cancelled_WorkOrder_For_DispatchBoard_Grid: "/DispatchBoard/GetCancelledWorkOrderForDispatchBoardGrid",
    Get_Recent_WorkOrder_For_DispatchBoard_Grid: "/DispatchBoard/getRecentWorkOrder",
    Get_All_Technicians: "/DispatchBoard/GetAllTechnicians",
    Get_DispatchBoard_WorkOrders_By_Date: "/DispatchBoard/GetDispatchBoardWorkOrdersByDate",
    Get_Dispatch_Board_Time_Slots_By_Date: "/DispatchBoard/GetDispatchBoardTimeSlotsByDate",
    Add_Employee_Custom_Block_Time: "/DispatchBoard/AddEmployeeCustomBlockTime",
    Remove_Employee_Custom_Block_Time: "/DispatchBoard/RemoveEmployeeCustomBlockTime",
    Update_WorkOrder_From_External_Drag_And_Drop: "/DispatchBoard/UpdateWorkOrderFromExternalDragAndDrop",
    Edit_WorkOrder_On_Dispatch_Board: "/DispatchBoard/EditWorkOrder",
    Accept_WorkOrder_By_Tech: "/DispatchBoard/AcceptWorkOrderByTech",
    Update_WorkOrder_Status_To_Pause: "/DispatchBoard/UpdateWorkOrderStatusToPause",
    Resume_WorkOrder: "/DispatchBoard/ResumeWorkOrder",
    Update_WorkOrder_Status_To_UnAssign: "/DispatchBoard/UpdateWorkOrderStatusToUnAssign",
    Update_WorkOrder_Status_To_Cancel: "/DispatchBoard/UpdateWorkOrderStatusToCancel",
    Update_WorkOrder_Status_To_Hold: "/DispatchBoard/UpdateWorkOrderStatusToHold",
    Get_Total_WorkOrders_Count_For_Dispatch_Board_Grid: "/DispatchBoard/GetTotalWorkOrdersCountForDispatchBoardGrid",
    Get_WorkOrders_By_Date_For_Test: "/DispatchBoard/GetWorkOrdersByDateForTest",
    Get_Secondary_WorkOrder_List_By_Date_For_Test: "/DispatchBoard/GetSecondaryWorkOrderListByDateForTest",
    Get_Technicians_To_Assign_As_Secondary_Tech: "/DispatchBoard/GetTechniciansToAssignAsSecondaryTech",
    Add_Secondary_Techs: "/DispatchBoard/AddSecondaryTechs",
    Get_All_Teams: "/DispatchBoard/GetAllTeams",
    Create_Quick_WorkOrder: "/DispatchBoard/CreateQuickWorkOrder",
    get_WorkOrder_And_Tecnician_For_Map: "/DispatchBoard/getWorkOrderAndTecnicianForMap",
    Get_Dispatch_Board_Setting_For_Dispatch_Board: "/DispatchBoard/GetDispatchBoardSettingForDispatchBoard",


    // Dispatch board setting
    Get_Dispatch_Board_Setting_For_Edit: "/DispatchBoardSetting/GetDispatchBoardSettingForEdit",
    Create_Dispatch_Board_Setting: "/DispatchBoardSetting/CreateDispatchBoardSetting",


    //Estimate WorkOrder Service API////
    Get_EstimatedInvoiceServiceList: "/EstimateWorkOrder/GetEstimatedInvoiceServiceList",
    Get_AllServicesForEstimatedInvoice: "/EstimateWorkOrder/GetAllServicesForEstimatedInvoice",
    Add_Update_EstimatedInvoiceServices: "/EstimateWorkOrder/AddUpdateEstimatedInvoiceServices",
    Delete_EstimatedInvoiceService: "/EstimateWorkOrder/DeleteEstimatedInvoiceService",
    EstimateInvoice_GetAll: "/EstimateWorkOrder/GetAll",
    UpdateInvoiceServicesTab_EstimateInvoice: "/EstimateWorkOrder/UpdateInvoiceServicesTab",
    ConvertToEstimateInvoice_EstimateInvoice: "/EstimateWorkOrder/ConvertWorkOrderToEstimate",
    EstimateWorkOrder_ConvertEstimateToSoldJob: "/EstimateWorkOrder/ConvertEstimateToSoldJob",


    // QBConnect/Connect
    QBConnect_Index: "/QBConnect/Index",
    QBConnect_Connect: "/QBConnect/Connect",

    // QBO
    QBO_CreateCustomer: "/QBO/CreateCustomer",
    QBO_ImportQBData: "/QBO/ImportQBData",
    QBO_SyncQBData: "/QBO/SyncQBData",
    QBO_LoadAccountsInfo: "/QBO/LoadAccountsInfo",
    QBO_SaveAccountsTokens: "/QBO/SaveAccountsTokens",
    QBO_GetSelectedValueForDropdown: "/QBO/GetSelectedValueForDropdown",
    QBO_GetLatestSyncLog: "/QBO/GetLatestSyncLog",
    QBO_GetOAuth2KeysFroEdit: "/QBO/GetOAuth2KeysFroEdit",
    QBO_SaveOAuth2Keys: "/QBO/SaveOAuth2Keys",

    // Air BNB
    Airbnb_ImportCalendarAndCreateWorkOrders: "/Airbnb/ImportCalendarAndCreateWorkOrders",





    ///Admin Portal///
    Prospects_GetAll: "/Prospects/GetAll",
    Prospects_Create: "/Prospects/Create",
    Prospects_Update: "/Prospects/Update",
    Prospects_Get: "/Prospects/Get",
    Prospects_Delete: "/Prospects/Delete",
    Prospects_CreateAccount: "/Prospects/CreateAccount",
    Prospects_GetProspectsByStatus: "/Prospects/GetProspectsByStatus",
    Prospects_GetProspectStatusDropdown: "/Prospects/GetProspectStatusDropdown",


    //TENANT//
    Tenant_Create: "/Tenant/Create",
    Tenant_UpdateTenant: "/Tenant/UpdateTenant",
    Tenant_GetTenantsWithFilter: "/Tenant/GetTenantsWithFilter",
    Tenant_ConvertProspectToTenant: "/Tenant/ConvertProspectToTenant",
    Tenant_GetAllAvailableFeatures: "/Tenant/GetAllAvailableFeatures",
    Tenant_GetTenantById: "/Tenant/GetTenantById",
    Tenant_Delete: "/Tenant/Delete",
    Tenant_SoftDelete: "/Tenant/SoftDelete",
    Tenant_GetAllTenantsForDropdown: "/Tenant/GetAllTenantsForDropdown",
    Tenant_GetSubscriptionComparison: "/Tenant/GetSubscriptionComparison",
    Tenant_GetProspectStatusSummary: "/Tenant/GetProspectStatusSummary",
    Tenant_ToggleTenantActive: "/Tenant/ToggleTenantActive",
    Tenant_GetTenantStatuses: "/Tenant/GetTenantStatuses",
    //Credit Card////
    CreditCard_Create: "/CreditCard/Create",
    CreditCard_Update: "/CreditCard/Update",
    CreditCard_GetAll: "/CreditCard/GetAll",
    CreditCard_Get: "/CreditCard/Get",
    CreditCard_GetCreditCardTypes: "/CreditCard/GetCreditCardTypes",
    CreditCard_GetAllStates: "/CreditCard/GetAllStates",
    CreditCard_GetByTenantId: "/CreditCard/GetByTenantId",
    CreditCard_Delete: "/CreditCard/Delete",




    ////Subscriptions///
    Subscription_CreateBillingCycle: "/Subscription/CreateBillingCycle",
    Subscription_GetAllBillingCycles: "/Subscription/GetAllBillingCycles",
    Subscription_UpdateBillingCycle: "/Subscription/UpdateBillingCycle",
    Subscription_CreateSubscriptionPlan: "/Subscription/CreateSubscriptionPlan",
    Subscription_GetAllSubscriptionPlans: "/Subscription/GetAllSubscriptionPlans",
    Subscription_GetAllSubscriptions: "/Subscription/GetAllSubscriptions",
    Subscription_ForceCancel: "/Subscription/ForceCancelSubscription",
    Subscription_GetSubscriptionPlansByTenant: "/Subscription/GetSubscriptionPlansByTenant",
    Subscription_GetBillingCyclesByTenantId: "/Subscription/GetBillingCyclesByTenantId",
    Subscription_UpdateSubscriptionPlan: "/Subscription/UpdateSubscriptionPlan",
    Subscription_UpdateSubscription: "/Subscription/UpdateSubscription",
    Subscription_GetAllPayments: "/Subscription/GetAllPayments",
    Subscription_SubscribeToPlan: "/Subscription/SubscribeToPlan",
    Subscription_GetSubscriptionPlanById: "/Subscription/GetSubscriptionPlanById",
    GetAll_SubscriptionStatusesBy_TenantId: "/Subscription/GetAllSubscriptionStatusesByTenantId",
    Subscription_Generate_Invoice: "/Subscription/GenerateInvoice",
    Subscription_SendInvoiceEmail: "/Subscription/SendInvoiceEmail",
    Subscription_GetFeaturePrices: "/Subscription/GetFeaturePrices",
    Subscription_SetFeaturePrices: "/Subscription/SetFeaturePrices",
    Subscription_PaySubscriptionBalance: "/Subscription/PaySubscriptionBalance",
    Subscription_GetDedicatedFeatures: "/Subscription/GetDedicatedFeatures",
    Subscription_AssignDedicatedFeature: "/Subscription/AssignDedicatedFeature",
    Subscription_UpdateDedicatedFeature: "/Subscription/UpdateDedicatedFeature",
    Subscription_PayDedicatedFeatureBalance: "/Subscription/PayDedicatedFeatureBalance",
    Subscription_RemoveDedicatedFeature: "/Subscription/RemoveDedicatedFeature",



    /////// TenantSetting////

    Tenant_Setting_GetAll: "/TenantSettings/GetAll",
    Tenant_Setting_Create: "/TenantSettings/Create",
    Tenant_Setting_Update: "/TenantSettings/Update",
    Tenant_Setting_Delete: "/TenantSettings/Delete",
    Tenant_Setting_GetTenantSettingsByName: "/TenantSettings/GetTenantSettingsByName",



    ////Roles////
    Role_GetAll: "/Role/GetAll",
    Role_Create: "/Role/Create",
    Role_Update: "/Role/Update",
    Role_Delete: "/Role/Delete",
    Role_GetAllPermissions: "/Role/GetAllPermissions",



    Permission_GetAllPermissions: "/Permission/GetAllPermissions",
    Permission_GetPermissionsByRoleId: "/Permission/GetPermissionsByRoleId",
    Permission_UpdateRolePermissions: "/Permission/UpdateRolePermissions",


    ///////USER////
    User_Create: "/User/Create",
    User_GetAll: "/User/GetAll",
    User_Delete: "/User/Delete",

    ////TenantUser///
    Tenant_GetAllTenantUsers: "/Tenant/GetAllTenantUsers",
    Tenant_IsEmailUnique: "/Tenant/IsEmailUnique",
    Tenant_IsCompanyNameUnique: "/Tenant/IsCompanyNameUnique",
    Tenant_IsTenancyNameUnique: "/Tenant/IsTenancyNameUnique",


    ////Dashboard//
    Tenant_GetDashboardCounts: "/Tenant/GetDashboardCounts",



////Enviroment///

 DatabaseSwitch_environments: "/DatabaseSwitch/environments",

    // Environment Configuration
    EnvConfig_GetDashboard: "/EnvironmentConfiguration/GetDashboard",
    EnvConfig_GetEnvironments: "/EnvironmentConfiguration/GetEnvironments",
    EnvConfig_CreateEnvironment: "/EnvironmentConfiguration/CreateEnvironment",
    EnvConfig_UpdateEnvironment: "/EnvironmentConfiguration/UpdateEnvironment",
    EnvConfig_DeleteEnvironment: "/EnvironmentConfiguration/DeleteEnvironment",
    EnvConfig_CreateDatabaseType: "/EnvironmentConfiguration/CreateDatabaseType",
    EnvConfig_UpdateDatabaseType: "/EnvironmentConfiguration/UpdateDatabaseType",
    EnvConfig_DeleteDatabaseType: "/EnvironmentConfiguration/DeleteDatabaseType",
    EnvConfig_GetDatabaseTypes: "/EnvironmentConfiguration/GetDatabaseTypes",
    EnvConfig_GetDatabaseConfigurations: "/EnvironmentConfiguration/GetDatabaseConfigurations",
    EnvConfig_CreateDatabaseConfiguration: "/EnvironmentConfiguration/CreateDatabaseConfiguration",
    EnvConfig_UpdateDatabaseConfiguration: "/EnvironmentConfiguration/UpdateDatabaseConfiguration",
    EnvConfig_DeleteDatabaseConfiguration: "/EnvironmentConfiguration/DeleteDatabaseConfiguration",
    TenantRegistrationSettings_Get: "/TenantRegistrationSettings/Get",
    TenantRegistrationSettings_Update: "/TenantRegistrationSettings/Update",
  },

  powerbiURLs: {
  },
  external: {
  }

};

